import React from 'react';
import CommonSFTPErrorsApp from './CommonSFTPErrorsApp';

const CommonSFTPErrorsEntry = () => {
  return <CommonSFTPErrorsApp />;
};

export default CommonSFTPErrorsEntry;
